export default __webpack_public_path__ + "static/media/right-fist.71bb5dff.svg";